<template>
  <div v-if="lexiconData" class="attribution-footer">
    <button
      class="attribution-toggle"
      :class="{ active: showAttribution }"
      @click="toggleAttribution"
    >
      <font-awesome-icon icon="info-circle" />
    </button>
    <div v-if="showAttribution" class="attribution-content">
      <div v-if="lexiconData.title" class="attribution-section">
        <strong>Title:</strong> {{ lexiconData.title }}
      </div>
      <div v-if="lexiconData.rights" class="attribution-section">
        <strong>Rights:</strong> {{ lexiconData.rights }}
      </div>
      <div v-if="lexiconData.attribution" class="attribution-section">
        <strong>Attribution:</strong> {{ lexiconData.attribution }}
      </div>
      <div v-if="lexiconData.source" class="attribution-section">
        <strong>Source:</strong>
        <a
          class="source-link"
          :href="lexiconData.source"
          target="_blank"
          rel="noopener noreferrer"
          >{{ lexiconData.source }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AttributionFooter',
    props: {
      lexiconData: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        showAttribution: false,
      };
    },
    methods: {
      toggleAttribution() {
        this.showAttribution = !this.showAttribution;
      },
    },
  };
</script>

<style scoped lang="scss">
  .attribution-footer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .attribution-toggle {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5em;
    font-size: 0.9em;
    transition: color 0.2s;
    &.active {
      color: #0066cc;
    }
    &:hover {
      color: #004499;
    }
  }
  .attribution-content {
    margin-top: 0.5em;
    padding: 0.75em;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 0.25em;
    font-size: 0.85em;
  }
  .source-link {
    margin-inline-start: 0.5em;
  }
  .attribution-section {
    margin-bottom: 0.5em;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: #333;
    }
  }
</style>
